export default __webpack_public_path__ + "static/media/Icon_Status_Outline_Info.2a5dbcfa.svg";